// @mui
import { styled, alpha } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
// auth
import { useAuthContext } from "../../../auth/useAuthContext";
// components
import { CustomAvatar } from "../../../components/custom-avatar";
import { getUserAuthTypeOption } from "src/utils/user";

// ----------------------------------------------------------------------

const StyledRoot = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

// ----------------------------------------------------------------------

export default function NavAccount() {
  const { user } = useAuthContext();

  const userRole = getUserAuthTypeOption(user)?.name;

  return (
    <StyledRoot>
      <CustomAvatar
        src={undefined}
        alt={user?.nickname}
        name={user?.nickname}
      />

      <Box sx={{ ml: 2, minWidth: 0 }}>
        <Typography variant="subtitle2" noWrap>
          {user?.nickname}
        </Typography>

        <Typography variant="body2" noWrap sx={{ color: "text.secondary" }}>
          {userRole}
        </Typography>
      </Box>
    </StyledRoot>
  );
}
